import { render, staticRenderFns } from "./watchlogin.vue?vue&type=template&id=774a284e&"
import script from "./watchlogin.vue?vue&type=script&lang=js&"
export * from "./watchlogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports